// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subHours as fn } from "../subHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subHours = convertToFP(fn, 2);

// Fallback for modularized imports:
export default subHours;
